<sim-base-chip-input
	[formState]="roomFc"
	[label]="label"
	[placeholder]="placeholder"
	[autoCompleteGroupedValues]="autoCompleteGroupedData"
	[hasGroupedValues]="true"
	[isMultiSelect]="canSelectMultipleRooms"
	[detailButtonConfig]="{
		tooltip: T.SHARED_SIM_ADVANCED_BASIC_INPUT_SHOW_DETAIL | translate,
	}"
	(optionSelected)="optionSelected.emit($event)"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(detailButtonClicked)="openRoomSelectionDialog()"
	[alternativeColorIds]="occupiedRoomIds"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>

	<mat-icon detailButtonContent inline fontSet="fad" fontIcon="fa-th" />
</sim-base-chip-input>
